export const canReplayAfterWake = (method?: string): boolean =>
  ['get', 'head', 'options'].includes(String(method || 'get').toLowerCase());

export const isSleepingGatewayStatus = (status?: number): boolean =>
  status !== undefined && [502, 503, 504].includes(status);
